export const COLUMNS_HEADERS = {
  description: { sortable: false },
  device: { sortable: false },
  finished: { sortable: false },
};
